//Polyfills
import 'whatwg-fetch'
import PolyfillArrayFrom from './vendors/polyfill-arrayfrom';
import Promise from './vendors/polyfill-promise';
import './vendors/polyfill-array-methods';
import 'es6-promise/auto';
import './vendors/polyfill-isInteger';
import './vendors/polyfill-object-assign';

if (!Array.from) {
    window.PolyfillArrayFrom = PolyfillArrayFrom;
}
if (!window.Promise) {
    window.Promise = Promise;
}

// Aborted fetches (navigation away, request superseded) are expected cancellations,
// not crashes — keep them out of error tracking (Matomo crash reports).
window.addEventListener('unhandledrejection', function (event) {
    if (event.reason && event.reason.name === 'AbortError') {
        event.preventDefault();
    }
});

import Parallax from './modules/parallax';
import Accordion from './modules/accordion';
import AnchorScroll from './modules/anchorScroll';
import Search from './modules/search';
import SearchSuggest from './modules/searchsuggest';
import Basket from './modules/basket';
import PublicationPage from './modules/publicationPage';
import Checkout from './modules/checkout';
import FormGenerel from './modules/formGenerel';
import Share from './modules/share';
import ImageMagnifier from './modules/imageMagnifier';
import './modules/cardsCarousel';
import MediaPopup from './modules/mediaPopup.js';
import Dropdown from './modules/dropdown';
import TableBlock from './modules/tableBlock';


new Parallax();
new Accordion();
new AnchorScroll();
new Search();
new SearchSuggest();
new Basket();
new PublicationPage();
new Checkout();
new FormGenerel();
new Share();
new MediaPopup();
new TableBlock();


import hoverIntent from './vendors/hoverIntent';
import navigation from './modules/navigation';
import bootpag from './vendors/bootpag.min';
import products from './modules/productsOverview';
import product from './modules/productPage';
import courses from './modules/coursesOverview';
import calendar from './modules/coursesCalendar';
import cookieBanner from './modules/cookieBanner';
import fullWidthBlocks from './modules/fullWidthBlocks';
import slick from 'slick-carousel';
import ntiSlickSlider from './modules/slickCarousel';

import './components'




$(".flexnav").flexNav();
Dropdown.initAll('.dropdown-toggle', { hover: false });

// Fix Bootstrap collapse for elements with numeric IDs (e.g. data-target="#4").
// BS4's getSelectorFromElement calls querySelector('#4'), which throws and returns
// null, so the data-API never animates. Drive the transition manually here.
// Animates margin alongside height so the element's vertical margins fade in/out
// instead of stepping (which would jump adjacent siblings by margin-size).
document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-toggle="collapse"]');
    if (!trigger) return;
    var selector = trigger.getAttribute('data-target') || trigger.getAttribute('href');
    if (!selector || selector.length < 2 || selector[0] !== '#') return;
    var id = selector.substring(1);
    if (!/^\d/.test(id)) return; // only fix numeric-starting IDs
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    if (target.dataset.animating === '1') return;
    target.dataset.animating = '1';

    var isOpen = target.classList.contains('show');
    var cs = window.getComputedStyle(target);
    var naturalMarginTop = cs.marginTop;
    var naturalMarginBottom = cs.marginBottom;

    target.style.transition = 'height 0.35s ease, margin 0.35s ease';
    target.style.overflow = 'hidden';
    target.classList.add('show'); // ensure visible during animation

    var onEnd = function (ev) {
        if (ev && (ev.target !== target || ev.propertyName !== 'height')) return;
        target.removeEventListener('transitionend', onEnd);
        target.style.transition = '';
        target.style.overflow = '';
        target.style.height = '';
        target.style.marginTop = '';
        target.style.marginBottom = '';
        if (isOpen) target.classList.remove('show'); // .collapse:not(.show) hides it
        delete target.dataset.animating;
    };

    if (isOpen) {
        // hide: pin current height + margins, then animate to 0
        target.style.height = target.getBoundingClientRect().height + 'px';
        target.style.marginTop = naturalMarginTop;
        target.style.marginBottom = naturalMarginBottom;
        target.offsetHeight; // reflow
        target.style.height = '0';
        target.style.marginTop = '0';
        target.style.marginBottom = '0';
    } else {
        // show: start at 0, animate to natural height + margins
        target.style.height = '0';
        target.style.marginTop = '0';
        target.style.marginBottom = '0';
        target.offsetHeight; // reflow
        target.style.height = target.scrollHeight + 'px';
        target.style.marginTop = naturalMarginTop;
        target.style.marginBottom = naturalMarginBottom;
    }
    target.addEventListener('transitionend', onEnd);
});